import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const OneYear: FC = () => {
  return (
    <Box mt={1}>
        <Header>
            <Box display={'flex'}>
                <Typography mb={1} ml={2}>Возраст</Typography>
                <Typography mb={1} ml={10}>Специалисты</Typography>
                <Typography mb={1} ml={20}>Виды обследования</Typography>
            </Box>
            <Box>
                <Box>
                    <TextField
                        value="1 месяц"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Ультразвуковое исследование органов брюшной полости (комплексное)"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Невролог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        value="Ультразвуковое исследование почек"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Детский хирург"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        value="Ультразвуковое исследование тазобедренных суставов"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Офтальмолог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        value="Эхокардиография"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Детский стоматолог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        value="Нейросонография"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="аудиологический скрининг"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1, ml: 42   }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="2 месяца"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Общий анализ крови"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Общий анализ мочи"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1, ml: 42  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="3 месяца"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                        sx={{ width: "200px", mb: 1, ml: 74.6  }}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Травматолог-ортопед"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, ml: 16, mr: 1  }}
                    />
                    <TextField
                        value="Общий анализ мочи"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Невролог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, ml: 16, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                        sx={{ width: "200px", mb: 1, ml: 74.6  }}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="4 месяца"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="5 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="6 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Невролог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, ml: 16, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="7 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="8 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="9 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Невролог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, ml: 16, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="10 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="11 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1 }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

            <Box>
                <Box>
                    <TextField
                        value="12 месяцев"
                        variant="outlined"
                        size="small"
                        sx={{ width: "120px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Педиатр"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1  }}
                    />
                    <TextField
                        value="Общий анализ крови"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Невролог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        value="Общий анализ мочи"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Детский хирург"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        value="Электрокардиография"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Оториноларинголог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Травматолог-ортопед"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Офтальмолог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
                <Box>
                    <TextField
                        value="Невролог"
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1, ml: 16  }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1  }}
                    />
                    <FormControlLabel
                        label="Пройден"
                        control={<Checkbox defaultChecked />}
                    />
                </Box>
            </Box>

        </Header>
    </Box>
  );
};

export default OneYear;